import { Collection, CollectionPrinter, Div, Link } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { Opinion } from "../../../Models/Description/Opinion/Opinion";
import { FieldEditor } from "../../Utils/FieldEditor";
import { OpinionEdit } from "./OpinionEditor";
import { OpinionField } from "../../../Models/Description/Opinion/OpinionField";
import { Tab } from "../../../Models/Product/Tab";
import { SecondaryButton } from "../../Utils/SecondaryButton";


export class OpinionsEditor extends FieldEditor
{
    constructor(field: OpinionField, fields: Collection<Field>, tabs: Collection<Tab>)
    {
        super("Opinie", field, fields, tabs, [
            new CollectionPrinter(field.Opinions, x => new OpinionEdit(x, field.Opinions)),
            new SecondaryButton("➕ Dodaj opinię").OnClick(() => field.Opinions.Add(new Opinion({ Author: "Anonim", Rate: 5 }))),
        ]);
    }
}
